import type { Snapshot } from '@/entities/snapshot';
import request from '@/shared/api/request';

export const getStackletSnapshots = (id: number): Promise<{ snapshots: Snapshot[] }> =>
  request({
    url: `/stacklets/${id}/snapshots/`,
  });
